import { type VueQueryPluginOptions, VueQueryPlugin } from '@tanstack/vue-query';
import flagsmithVue from 'flagsmith-vue';
import { createApp } from 'vue';

import { createApiClient, createHttpClient } from '@abaninja/util-http-client';
import 'unfonts.css';
import 'vuetify/styles';

import App from './App.vue';
import { initGtm } from './plugins/gtm';
import { i18n } from './plugins/i18n';
import { initKeycloak } from './plugins/keycloak';
import { pinia } from './plugins/pinia';
import { initSentry } from './plugins/sentry';
import { unhead } from './plugins/unhead';
import { createVeeValidate } from './plugins/vee-validate';
import { vuetify } from './plugins/vuetify';
import router from './router';
import './scss/base.scss';

const app = createApp(App);

// needs to be outside of cb function
app.use(initGtm(router));

const createApplication = () => {
  createHttpClient({
    baseURL: import.meta.env.VITE_API_URL,
  });

  createApiClient({
    baseURL: import.meta.env.VITE_API_URL,
  });

  initSentry(app, router);

  // init plugins
  app.use(vuetify);
  app.use(i18n);
  app.use(pinia);
  app.use(router);
  app.use(unhead);

  app.use(VueQueryPlugin, {
    enableDevtoolsV6Plugin: true,
    queryClientConfig: {
      defaultOptions: {
        queries: {
          staleTime: 20_000,
        },
      },
    },
  } satisfies VueQueryPluginOptions);

  app.use(flagsmithVue, {
    api: import.meta.env.VITE_FLAGSMITH_API,
    cacheFlags: true,
    enableAnalytics: true,
    enableLogs: import.meta.env.VITE_FLAGSMITH_ENABLE_LOGS === 'true',
    environmentID: import.meta.env.VITE_FLAGSMITH_ENVIRONMENT_ID,
  });

  createVeeValidate();

  app.mount('#root');
};

void initKeycloak(createApplication, router);
